export var DefaultGroupName = '_default_group';
export var DefaultGroupNameValue = 'Ungrouped';
// https://github.com/moment/moment/blob/develop/locale/en-gb.js
export var Weekdays = [
    { key: 'mon', text: 'Monday', short: 'Mon', min: 'M' },
    { key: 'tue', text: 'Tuesday', short: 'Tue', min: 'T' },
    { key: 'wed', text: 'Wednesday', short: 'Wed', min: 'W' },
    { key: 'thu', text: 'Thursday', short: 'Thu', min: 'T' },
    { key: 'fri', text: 'Friday', short: 'Fri', min: 'F' },
    { key: 'sat', text: 'Saturday', short: 'Sat', min: 'S' },
    { key: 'sun', text: 'Sunday', short: 'Sun', min: 'S' },
];
export var DATE_FORMAT_FOR_DB = 'yyyy-MM-dd';
export var DATE_FORMAT_FOR_FNS = 'MM/dd/yyyy';
export var DATE_FORMAT_FOR_DISPLAY = 'dd/MM/YYY';
export var TIME_FORMAT = 'HH:mm';
export var SortingActions;
(function (SortingActions) {
    SortingActions["SORT_BY_NAME"] = "SORT_BY_NAME";
    SortingActions["SORT_BY_STARRED"] = "SORT_BY_STARRED";
})(SortingActions || (SortingActions = {}));
export var ChangeTimeValueOperation;
(function (ChangeTimeValueOperation) {
    ChangeTimeValueOperation[ChangeTimeValueOperation["DEFAULT"] = 0] = "DEFAULT";
    ChangeTimeValueOperation[ChangeTimeValueOperation["PLUS"] = 1] = "PLUS";
    ChangeTimeValueOperation[ChangeTimeValueOperation["MINUS"] = -1] = "MINUS";
})(ChangeTimeValueOperation || (ChangeTimeValueOperation = {}));
export var DEFAULT_VALUE_FULL = '00:00:00';
export var DEFAULT_VALUE_SHORT = '00:00';
//# sourceMappingURL=constants.js.map